import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface LoadingProps {
  size?: number;
}

export default function Loading({ size = 80 }: LoadingProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <Typography variant="h2" component="h1" fontWeight={'700'}>
        FigurApp
      </Typography>
      <CircularProgress size={size} />
    </Box>
  );
}
